import _ from '../../utils/LodashImports';

const getLabels = (appCtx) => {
  const textDictionary = _.get(appCtx, 'siteConfig.textDictionary', {});
  return {
    text1: _.get(textDictionary, 'WHOLESALE_BANNER_BADGE_TEXT_1', 'Precio'),
    text2: _.get(textDictionary, 'WHOLESALE_BANNER_BADGE_TEXT_2', 'Volumen'),
    from: _.get(textDictionary, 'WHOLESALE_BANNER_BADGE_FROM', 'desde'),
    each: _.get(textDictionary, 'WHOLESALE_BANNER_BADGE_EACH', 'cada'),
    units: _.get(textDictionary, 'WHOLESALE_BANNER_BADGE_UNITS', 'un.'),
  };
};

export default getLabels;
